<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-spin :spinning="spinning">
        <a-form layout="inline" @keyup.enter.native="searchQuery">


          <a-row :gutter="12">
            <a-col :md="6" :sm="8">
              <a-form-item :label="'Type'">
                <a-select default-value="" style="width: 120px" v-model="queryParam.type">
                  <a-select-option value="1"> Single Period by Group </a-select-option>
                  <a-select-option value="2"> Single Period by Person </a-select-option>
                  <a-select-option value="3"> Installment by Group </a-select-option>
                  <a-select-option value="4"> Installment by Person </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="'Group ID or Collector ID separated by commas'" :labelCol="{ span: 2 }" :wrapperCol="{ span: 2, offset: 1 }">
                <a-textarea v-model="queryParam.ugIds" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="12">
              <a-form-item :label="'Order'" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
                <a-textarea v-model="queryParam.orderIds" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="12">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="fenPre" style="margin: 10px" icon="search">Pre-allocation Submit</a-button>
              <a-button type="primary" @click="intoQueqe" style="margin: 10px" icon="search">Order Queue Sorting</a-button>
              <a-button type="primary" @click="distrOrder" style="margin: 10px" icon="search">Queue Allocation</a-button>
              <a-button type="primary" @click="fenNight"  style="margin: 10px" icon="search">Night Collection Allocation (PK)</a-button>

            </a-col>
          </a-row>
        </a-form>
      </a-spin>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
      >
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import moment from 'moment'
import {
  appointDistributionTaskWeb,
  appointTaskQueryWeb,
  appointDistributionTaskWebInsertInto,
  appointDistributionTaskWebAssign, appointDistributionTaskNight
} from '@/webpublicapi/platformCollection'
import { abandonApplySend } from '@/webpublicapi/order'

export default {
  components: {},
  data() {
    return {
      visible: false,
      spinning: false,
      dataSource: [],
      loading: false,
      headers: {
        // authorization: 'authorization-text',
      },
      // Query conditions
      queryParam: {
        type: undefined,
        orderIds: undefined,
        ugIds: undefined,
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'Collector',
          align: 'left',
          dataIndex: 'user_id',
        },
        {
          title: 'Quantity',
          align: 'left',
          dataIndex: 'c',
        },
      ]
    },
  },
  created() {
  },
  methods: {
    getQueryParams() {
      const data = {
        ...this.queryParam,
      }
      return filterObj(data)
    },
    searchQuery() {
      this.loadData()
    },
    fenPre() {
      this.spinning = true
      var params = this.getQueryParams() // Query conditions
      appointDistributionTaskWeb(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.$message.info('AssignSuccess')
          } else {
            this.$message.error(res.msg)
          }
          this.spinning = false
        })
        .catch((e) => {
          this.spinning = false
          this.$message.error(e.message)
        })
    },
    fenNight() {

      const self = this;
      this.$confirm({
        title: 'Night Collection Order Assign',
        onOk() {
          self.spinning = true;
          appointDistributionTaskNight({}).then(res => {
            if (res.code === 1000) {
              self.$message.info('AssignSuccess')
            } else {
              self.$message.error(res.msg)
            }
            self.spinning = false
          }).catch(e => {
            self.spinning = false
            self.$message.error(e.message)
            return;
          })
        },
      });

      // this.spinning = true
      // var params = this.getQueryParams() // Query conditions
      // appointDistributionTaskNight(Object.assign({}, params))
      //   .then((res) => {
      //     if (res.code === 1000) {
      //       this.$message.info('Assignment success')
      //     } else {
      //       this.$message.error(res.msg)
      //     }
      //     this.spinning = false
      //   })
      //   .catch((e) => {
      //     this.spinning = false
      //     this.$message.error(e.message)
      //   })
    },
    intoQueqe() {
      this.spinning = true
      var params = this.getQueryParams() // Query conditions
      appointDistributionTaskWebInsertInto(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.$message.info('Enter Queue Success')
          } else {
            this.$message.error(res.msg)
          }
          this.spinning = false
        })
        .catch((e) => {
          this.spinning = false
          this.$message.error(e.message)
        })
    },
    distrOrder() {
      this.spinning = true
      var params = this.getQueryParams() // Query conditions
      appointDistributionTaskWebAssign(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.$message.info('AssignSuccess')
          } else {
            this.$message.error(res.msg)
          }
          this.spinning = false
        })
        .catch((e) => {
          this.spinning = false
          this.$message.error(e.message)
        })
    },
    loadData() {
      this.loading = true
      var params = this.getQueryParams() // Query conditions

      appointTaskQueryWeb(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.dataSource = res.data
          } else {
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
